import { lazy } from 'react';

import { SignUpRouteBase } from '@/App/AppRoutes/SignUpRouteBase';
import type { AppRouteConfig } from '@/App/AppRoutes/types';

const SignUpPage = lazy(() =>
  import('@/components/pages/SignUpPage').then(({ SignUpPage }) => ({ default: SignUpPage })),
);

export const SignUpRoute: AppRouteConfig = {
  ...SignUpRouteBase,
  component: SignUpPage,
};
